import styled from 'styled-components';
export var Trigger = styled.div.withConfig({
  componentId: "sc-12x8yss-0"
})(["height:100%;"]);